import React from 'react';
import { JavaScriptBasics, GlobalLayout } from '../'

const JavaScriptBasicsPage = (props) => (
  <GlobalLayout>
    <JavaScriptBasics {...props} />
  </GlobalLayout>
);

export default JavaScriptBasicsPage;